import request from '@utils/request';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { SpaPackageListingType } from 'shared-types/SpaPackage';
import { SPA_AVAILABILITY_TIMEOUT } from './consts';

export function useGetAvailableSpaPackages(
  propertyId: number,
  params: {
    category: number | null;
    perPage?: number;
    date: string;
    guests?: number;
  },
  language: string
) {
  return useQuery({
    queryKey: getAvailableSpaPackagesKey(propertyId, params, language),
    queryFn: () => getAvailableSpaPackages(propertyId, params, language),
    keepPreviousData: true,
  });
}

export async function getAvailableSpaPackages(
  propertyId: number,
  params: {
    category?: number | null;
    perPage?: number;
    date: string;
    guests?: number;
  },
  language: string
) {
  const { guests, ...rest } = params;
  const requestParams = {
    category: null,
    perPage: 0,
    ...rest,
    ...(guests !== undefined ? { numberOfGuests: guests } : {}),
  };
  const { data } = await request.get(`${propertyId}/spa-packages/${language}`, {
    params: requestParams,
    isPayloadCaseConverterDisabled: true,
    timeout: SPA_AVAILABILITY_TIMEOUT,
  });

  return data.data as SpaPackageListingType[];
}

export const getAvailableSpaPackagesKey = (
  propertyId: number,
  params: {
    category: number | null;
    perPage?: number;
    date: string;
    guests?: number;
  },
  language: string
) => ['spaPackages', 'available', propertyId, ...Object.values(params), language];

export const getAvailableSpaPackagesPrefetch = (
  queryClient: QueryClient,
  propertyId: number,
  params: {
    category: number | null;
    perPage?: number;
    date: string;
    guests?: number;
  },
  language: string
) =>
  queryClient.prefetchQuery(getAvailableSpaPackagesKey(propertyId, params, language), () =>
    getAvailableSpaPackages(propertyId, params, language)
  );
